import VeeValidate from "vee-validate";
import Vue from "vue";
import Component from "vue-class-component";
import "../global.scss";
export default Vue;
Vue.use(VeeValidate);
export { Component, VeeValidate };



//////////////////
// WEBPACK FOOTER
// ./app/shared/vue-config.ts
// module id = 28
// module chunks = 0 1 2 3 4 5